import React from "react";
import { cn } from "../../../lib/utils";

interface GatewayStatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  subtitle?: string;
  colorClass?: string;
  className?: string;
}

export default function GatewayStatCard({ icon, label, value, subtitle, colorClass = "text-primary", className }: GatewayStatCardProps) {
  return (
    <div className={cn(
      "rounded-xl border border-border bg-card shadow-sm backdrop-blur-sm p-5 flex flex-col gap-3 hover:border-border transition-all",
      className
    )}>
      <div className="flex items-center justify-between">
        <span className={cn("flex items-center justify-center w-10 h-10 rounded-lg bg-muted/80", colorClass)}>
          {icon}
        </span>
        {subtitle && <span className="text-xs text-muted-foreground">{subtitle}</span>}
      </div>
      <div>
        <div className="text-2xl font-bold text-foreground tracking-tight">{value}</div>
        <div className="text-xs text-muted-foreground uppercase tracking-wider mt-1">{label}</div>
      </div>
    </div>
  );
}
